<div style="padding: 24px;">

  <!-- <h2 class="page-title" style="margin:8px 0px 32px 0px">{{'Dokumente.title' | translate}}</h2>-->

  <mat-form-field appearance="fill" class="input-field" floatLabel="always">
    <mat-label>{{'Dokumente.erstelldatumvon' | translate}}</mat-label>

    <input matInput style="margin: 0px"
      [ngModel]="search.Von | date:'dd.MM.yyyy'" (ngModelChange)="search.Von=this.oroservice.ChangeDate($event);"
      (change)="searchCick()" autocomplete='off'>
      <input type="hidden" [matDatepicker]="pickerVon" [(ngModel)]='search.Von' (dateChange)="searchCick()">

      <mat-datepicker-toggle matSuffix [for]="pickerVon" tabindex="-1"></mat-datepicker-toggle>
      <mat-datepicker #pickerVon></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="fill" class="input-field" floatLabel="always">
      <mat-label>{{'Dokumente.erstelldatumbis' | translate}}</mat-label>

      <input matInput style="margin: 0px"
        [ngModel]="search.Bis | date:'dd.MM.yyyy'" (ngModelChange)="search.Bis=this.oroservice.ChangeDate($event);"
        (change)="searchCick()" autocomplete='off'>
        <input type="hidden" [matDatepicker]="pickerBis" [(ngModel)]='search.Bis' (dateChange)="searchCick()">

        <mat-datepicker-toggle matSuffix [for]="pickerBis" tabindex="-1"></mat-datepicker-toggle>
        <mat-datepicker #pickerBis></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="fill" class="input-field">
        <mat-label>{{'Dokumente.Dokumentart' | translate}}</mat-label>
        <mat-select [(ngModel)]="search.Art" (selectionChange)="searchCick()">
          @for (dokart of this.oroservice.kundeninfo.Dokumentarten; track dokart) {
            <mat-option [value]="dokart.Id">
              {{this.oroservice.getCaption(dokart)}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="input-field">
        <mat-label>{{'Dokumente.Gelesen' | translate}}</mat-label>
        <mat-select [(ngModel)]="search.Gelesen" (selectionChange)="searchCick()">
          <mat-option [value]="0">{{'Dokumente.Alle' | translate}}</mat-option>
          <mat-option [value]="1">{{'Dokumente.Ungelesen' | translate}}</mat-option>
          <mat-option [value]="2">{{'Dokumente.Gelesen' | translate}}</mat-option>
        </mat-select>
      </mat-form-field>

      <div class="no-padding action-buttons">
        <button mat-button color="primary" (click)="downloadSelected()" style="width: auto;">
          <mat-icon>get_app</mat-icon>&nbsp;{{'Dokumente.Downloadausgewaehlte' | translate}}
        </button>
        <button mat-button color="primary" (click)="setRead()" style="width: auto">
          <mat-icon>done</mat-icon>&nbsp;{{'Dokumente.Gelesenausgewaehlte' | translate}}
        </button>
      </div>

      @if (this.update) {
        <div>
          <mat-progress-bar mode="indeterminate" style="margin-top: 4px; margin-bottom: 4px;"></mat-progress-bar>
        </div>
      }

      @if (!this.update && dokumente.length == 0) {
        <div class="row no-padding">
          {{'NoResult' | translate}}
        </div>
      }

      @if (!this.update && dokumente.length > 0) {
        <div class="row no-padding">
          <table mat-table [dataSource]="dataSource" style="width: 100%;" class="mat-elevation-z2">
            <ng-container matColumnDef="Markiert">
              <mat-header-cell *matHeaderCellDef>
                <mat-checkbox style="margin-left: 12px; margin-top: 4px;" color="primary" [(ngModel)]="allselected"
                  (click)="switchselectall()">
                </mat-checkbox>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <mat-checkbox style="margin-left: 12px; margin-top: 4px;" color="primary"
                [(ngModel)]="element.Selected"></mat-checkbox>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="Art">
              <mat-header-cell *matHeaderCellDef>{{'Art' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" [ngStyle]="{'font-weight':element.Gelesen? 'normal' : 'bold' }">
              {{element.Art | translate}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="Seiten">
              <mat-header-cell *matHeaderCellDef>{{'Seiten' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" [ngStyle]="{'font-weight':element.Gelesen? 'normal' : 'bold' }">
              {{element.Seiten}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="Datum">
              <mat-header-cell *matHeaderCellDef>{{'Datum' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" [ngStyle]="{'font-weight':element.Gelesen? 'normal' : 'bold' }">
              {{element.Datum}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="Dossier">
              <mat-header-cell *matHeaderCellDef>{{'Dossier.label' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" [ngStyle]="{'font-weight':element.Gelesen? 'normal' : 'bold' }">
              {{dossiernummerToString(element.Dossier)}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="Dokument">
              <mat-header-cell *matHeaderCellDef>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <button mat-icon-button (click)="this.OpenDoc(element, element.Art)" style="margin:0px">
                  <mat-icon>visibility</mat-icon>
                </button>
              </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="dokumenteColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: dokumenteColumns;"></mat-row>
          </table>
        </div>
      }

      <mat-paginator
        [pageSizeOptions]="[10, 20, 50]"
        showFirstLastButtons
        aria-label="Select page of documents"
        (page)="updateValidator()">
      </mat-paginator>
    </div>
